const amount_rounded_to_cents = function (pNum, pOptions) {
  if (!pOptions) pOptions = {};
  const return_type = pOptions.return_type || `string`;//string||number

  const s = parseFloat(pNum).toFixed(2);
  let r;
  if (return_type === `string`) {
    r = s;
  }
  if (return_type === `number`) {
    r = parseFloat(s);
  }
  return r;
};

module.exports = amount_rounded_to_cents;
